export default __webpack_public_path__ + "static/media/next.ba380536.m4a";